import React, { Component } from "react";
import { Button, Form, Modal, Table } from "semantic-ui-react";
import "scss/components/modals/deviceModelPartsModal.scss";

export default class DeviceModelPartsModal extends Component {
  render() {
    // console.log(this.props.data);
    const spareDetail = this.props.data;
    // console.log(typeof spareDetail.image);
    return (
      // <div className="deviceModelPartsModal">
      <Modal
        dimmer="blurring"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Content scrolling>
          <div className="product">
            <div className="product-topic">
              <h3>Product Packing List</h3>
            </div>

            <div className="product-detail">
              <div className="product-detail-images">
                <p>
                  <b>Product</b>
                </p>
                <div className="image">
                  {typeof spareDetail.image === "string" &&
                    spareDetail.image !== "" && (
                      <img
                        alt="images"
                        src={require(`../../assets/SPARE_PARTS/${spareDetail?.image}`)}
                      />
                    )}
                </div>
              </div>

              <div className="product-detail-data">
                <p>
                  <span active="1">
                    <b>Update : </b>
                  </span>
                  {spareDetail?.update}
                </p>
                <div className="detail">
                  <div className="detail-content">
                    <div className="detail-content-topic">Model :</div>
                    <div className="detail-content-detail">
                      &emsp;
                      {spareDetail?.model === "" ? "-" : spareDetail?.model}
                    </div>
                  </div>

                  <div className="detail-content">
                    <div className="detail-content-topic">Date Launch :</div>
                    <div className="detail-content-detail">
                      &emsp;
                      {spareDetail?.dateLaunch === ""
                        ? "-"
                        : spareDetail?.dateLaunch}
                    </div>
                  </div>

                  <div className="detail-content">
                    <div className="detail-content-topic">Colour :</div>
                    <div className="detail-content-detail">
                      &emsp;
                      {spareDetail?.colour === "" ? "-" : spareDetail?.colour}
                    </div>
                  </div>

                  <div className="detail-content">
                    <div className="detail-content-topic">Stick Price :</div>
                    <div className="detail-content-detail">
                      &emsp;
                      {spareDetail?.stickPrice === ""
                        ? "-"
                        : spareDetail?.stickPrice}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="product-topic">
            <h3>Sales spare part list</h3>
          </div>

          <div>
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Picture</Table.HeaderCell>
                  <Table.HeaderCell>Detail</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {spareDetail?.parts?.map((device, idx) => (
                  <Table.Row key={idx}>
                    <Table.Cell>
                      <div>
                        {typeof spareDetail.image === "string" && (
                          <img
                            alt="images"
                            src={require(`../../assets/SPARE_PARTS/${device?.image}`)}
                          />
                        )}
                      </div>
                    </Table.Cell>
                    <Table.Cell>
                      <ul>
                        <li>
                          <b>Life :</b>
                          &ensp;{device?.life === "" ? "-" : device?.life}
                        </li>
                        <li>
                          <b>Q.T.Y :</b>
                          &ensp;{device?.qty === "" ? "-" : device?.qty}
                        </li>
                        <li>
                          <b>Price :</b>
                          &ensp;
                          {device?.price === ""
                            ? "-"
                            : device?.price.toLocaleString()}
                        </li>
                      </ul>
                    </Table.Cell>
                    <Table.Cell>
                      <b>Name :</b>
                      &emsp;{device?.name}
                      <br />
                      <b>Item Code :</b>
                      &emsp;{device?.itemCode}
                      <br />
                      <b>Lot Size / Leadtime :</b>
                      &emsp;{device?.lotSize}&nbsp;/&nbsp;{device?.leadTime}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        </Modal.Content>
      </Modal>
      // </div>
    );
  }
}
